module.exports = __webpack_public_path__ + "static/media/intro1.26e399c7.png";